import React from 'react';

import { useFormik } from 'formik';
import {
  // Link,
  useHistory,
} from 'react-router-dom';

import { storage } from 'modules/common/utils';
import { FormInput, Button } from 'modules/common/input';
import useTimeoutReady from 'modules/common/hooks/useTimeoutReady';

import { useLogin } from '../hooks';
import { loginSchema } from '../validation';

const INIT_FORM = {
  email: '',
  password: '',
};

function PartnerLoginForm() {
  const [isReady] = useTimeoutReady(100);
  // const multistore_website = process.env.REACT_APP_WEBSITE_DOMAIN;

  const history = useHistory();
  const [isApiLoading, login, canProceed] = useLogin('PARTNER');

  const { handleSubmit, setFieldValue, values, errors } = useFormik({
    initialValues: INIT_FORM,
    validationSchema: loginSchema,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (form) => {
      login(
        form,
        (res) => {
          if (typeof res === 'object' && res !== null) {
            const { user_uuid, method, receiver_end, receiver_start } =
              res || {};

            if (Object.hasOwn(res, 'method')) {
              history.push({
                pathname: '/multi-factor-auth',
                goBack: '/merchant-login',
                user_uuid,
                isAllowed: true,
                method,
                userType: 'partner',
                receiver_end,
                receiver_start,
              });
              return;
            }
          }

          if (res) {
            history.push('/onboarding');
            return;
          }

          history.push('/');
        },
        (err) => {
          const { error, token, time_remaining_for_retry } = err || {};

          if (error === 'login_failure_attempts') {
            storage.set('time_remaining_for_retry', time_remaining_for_retry);
            canProceed({ time_remaining_for_retry });
            return;
          }

          if (error === 'password_expired') {
            history.push({
              pathname: '/password-expired',
              token,
              goBack: '/merchant-login',
              isAllowed: true,
            });
          }
        }
      );
    },
  });

  return (
    <form onSubmit={handleSubmit} noValidate autoComplete="off">
      <div className="space-y-5">
        <FormInput
          name="email"
          label="Email"
          type="email"
          placeholder="Enter your email"
          autoFocus
          noautofill="true"
          value={values?.email || ''}
          onSetFieldValue={setFieldValue}
          error={errors?.email}
          required
          readOnly={isReady}
        />
        <div>
          <FormInput
            label="Password"
            name="password"
            placeholder="Enter your password"
            value={values?.password || ''}
            type="password"
            autoComplete="none"
            onSetFieldValue={setFieldValue}
            withShowPassword
            error={errors?.password}
            required
          />
          <div className="mt-2 flex">
            <Button
              className="font-medium text-primary-500 text-sm ml-auto"
              label="Forgot Password?"
              to="/forgot-password"
            />
          </div>
        </div>
        <div className="space-y-3 text-center">
          <div>
            <Button
              type="submit"
              withLoader
              isLoading={isApiLoading}
              className="btn primary md w-full"
              label="Login"
            />
          </div>
          <div>
            <Button
              to="/login"
              className="text-sm font-medium text-black hover:underline"
              label="Go back"
            />
          </div>
        </div>
      </div>
    </form>
  );
}
PartnerLoginForm.defaultProps = {};

PartnerLoginForm.propTypes = {};

export default PartnerLoginForm;
